<template>
    <section class="breadcrumbs">
        <div :class="[design, { 'container': container }]">
            <div class="content">
                <div class="col left">
                    <!-- @slot Use este slot para o conteúdo à esquerda -->
                    <strong v-if="$slots.left || isHome"> Você está em: </strong>
                    <span v-if="$slots.left || isHome" @click="goHome"> &#8226; Início &#8226; </span>
                    <span v-if="!isHome"/>
                    <slot name="left"/>
                    <span> -</span>
                    <span class="feedback">
                        <span @click="openFeedbackModal">O que achou desta tela?</span>
                    </span>
                </div>
                <div class="col right">
                    <slot name="right"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
	export default {
		name: 'ui-breadcrumbs',

		props: {
			design: {
				type: String,
				required: false,
				default: '',
			},
			container: {
				type: Boolean,
				required: false,
				default: true,
			},
		},

		data() {
			return {
				isHome: window.location.pathname == '/v2/' || window.location.pathname == '/v2-dev/',
			}
		},

		methods: {
			goHome() {
				this.$router.push('/')
			},

			openFeedbackModal() {
				this.$root.$emit('modal-open-feedback-modal')
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
